import { fetchApplication, fetchApplications } from '../../client/client';
import {
  fetchCountries,
  fetchJobTitles,
  fetchLanguages,
} from '../../client/serverMetaData';
import * as types from '../constants';

export const getApplicationSuccess = (details) => {
  return {
    type: types.GET_APPLICATION_DETAILS_SUCCESS,
    payload: {
      details,
    },
  };
};

export const getApplicationsSuccess = (applications) => {
  return {
    type: types.GET_APPLICATIONS_SUCCESS,
    payload: {
      applications,
    },
  };
};

export const getLanguagesSuccess = (languages) => {
  return {
    type: types.GET_APPLICATION_LANGUAGES_SUCCESS,
    payload: {
      languages,
    },
  };
};

export const getJobTitlesSuccess = (jobTitles) => {
  return {
    type: types.GET_APPLICATION_JOB_TITLES_SUCCESS,
    payload: {
      jobTitles,
    },
  };
};

export const getCountriesSuccess = (countries) => {
  return {
    type: types.GET_APPLICATION_COUNTRIES_SUCCESS,
    payload: {
      countries,
    },
  };
};

export const getApplicationDetails = (id) => {
  return async (dispatch) => {
    const { data } = await fetchApplication(id);
    dispatch(getApplicationSuccess(data));
  };
};

export const getApplications = () => {
  return async (dispatch) => {
    const { data } = await fetchApplications();
    dispatch(getApplicationsSuccess(data));
  };
};

export const getJobTitles = (language = 'en') => {
  return async (dispatch) => {
    const { data } = await fetchJobTitles(language);
    dispatch(getJobTitlesSuccess(data));
  };
};

export const getLanguages = (language = 'en') => {
  return async (dispatch) => {
    const { data } = await fetchLanguages(language);
    dispatch(getLanguagesSuccess(data));
  };
};

export const getCountries = (language = 'en') => {
  return async (dispatch) => {
    const { data } = await fetchCountries(language);
    dispatch(getCountriesSuccess(data));
  };
};
